import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box } from 'pcln-design-system'
import { MobileHeaderCard } from './MobileHeaderCard'
import { MobileModal } from '../MobileModal/MobileModal'
import { getFormattedDate } from './helpers'

const MobileHeader = ({
  filterOnClick,
  tripSlices,
  tripType,
  forceHeaderOpen,
  forceOpen,
  hideFilter,
  backArrowClick,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false)
  /* istanbul ignore next */
  const toggleIsOpen = () => {
    if (forceHeaderOpen) {
      forceHeaderOpen()
    } else {
      setIsOpen(!isOpen)
    }
  }

  return (
    <Box data-testid='mobile-change-search-header'>
      <MobileModal
        toggleIsOpen={toggleIsOpen}
        isOpen={isOpen || forceOpen}
        tripSlices={tripSlices}
        tripType={tripType}
        {...props}
      />
      <MobileHeaderCard
        toggleIsOpen={toggleIsOpen}
        filterOnClick={filterOnClick}
        origin={tripSlices?.[0]?.origAirportCode || ''}
        destination={tripSlices?.length > 0 ? tripSlices[tripSlices.length - 1]?.destAirportCode : ''}
        date={getFormattedDate(tripSlices, tripType)}
        hideFilter={hideFilter}
        backArrowClick={backArrowClick}
      />
    </Box>
  )
}

MobileHeader.propTypes = {
  airports: PropTypes.object,
  setAirports: PropTypes.func,
  isWhiteLabel: PropTypes.bool,
  pclnExpt: PropTypes.any,
  tripType: PropTypes.string,
  validationError: PropTypes.func,
  setTripType: PropTypes.func,
  cabinClass: PropTypes.string,
  setCabinClass: PropTypes.func,
  forceOpen: PropTypes.bool,
  forceHeaderOpen: PropTypes.func,
  passengers: PropTypes.object,
  setPassengers: PropTypes.func,
  useFlexDates: PropTypes.bool,
  setUseFlexDates: PropTypes.func,
  tripSlices: PropTypes.array,
  setTripSlices: PropTypes.func,
  filterOnClick: PropTypes.func,
  displayFlexibleDatesCheckbox: PropTypes.bool,
  hideFilter: PropTypes.bool,
  backArrowClick: PropTypes.func,
}

export { MobileHeader }
